import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, watch } from 'vue'

import AxisInput from '../components/axisInput.vue'
import CodeInput from '../components/codeInput.vue'
import FormItem from '../components/formItem.vue'
import inputTable from '../components/inputTable.vue'
import { Knif } from '../util/types'
import {
  axisList,
  codeList,
  holeSetting,
  knivesColumns,
  lmnSetting,
  slotSetting,
} from './customThirdConf'


export default /*#__PURE__*/_defineComponent({
  __name: 'customThird',
  props: {
    data: null
  },
  emits: ['onDataChange'],
  setup(__props: any, { emit }) {

const props = __props as { data: any }





const formData = reactive<{ [key: string]: any }>({
  beginCode: '',
  pauseCode: '',
  endCode: '',
  leftTurnCode: '',
  leftTurnEndCode: '',
  backTurnCode: '',
  backTurnEndCode: '',
  rightTurnCode: '',
  rightTurnEndCode: '',
  frontTurnCode: '',
  frontTurnEndCode: '',
  holeMove: '',
  punchHole: '',
  swingCode: '',
  holeStop: '',
  freeSlot: '',
  punchSlot: '',
  stopCode: '',
  horVerCutFace: '',
  horCutFace: '',
  verCutFace: '',
  lmnSetting: {
    lmnCut: '',
    lmnCutFace: '',
    lmnFree: '',
    lmnStop: '',
  },
  xPointSymbol: '',
  yPointSymbol: '',
  zPointSymbol: '',
  knives: [],
})

const currentSpecialSetting = ref('拉米诺')

const tableData = ref<Knif[]>([])

// 传入表单数据处理
watch(
  () => props.data,
  (val) => {
    if (val) {
      for (const key in formData) {
        formData[key] = val.settingV3[key]
      }
      tableData.value = formData.knives.map(
        (knif: any) => Knif.fromThirdSetting(knif) as Knif
      )
    }
  },
  {
    immediate: true,
  }
)

// 刀具库数据处理
watch(
  () => tableData.value,
  (val) => {
    formData.knives = val.map((knif) => Knif.fromThirdSetting(knif))
  },
  {
    deep: true,
  }
)

// 表单数据传出
watch(
  () => formData,
  (val) => {
    emit('onDataChange', val)
  },
  {
    deep: true,
  }
)

return { __sfc: true,props, emit, formData, currentSpecialSetting, tableData, AxisInput, CodeInput, FormItem, inputTable, axisList, codeList, holeSetting, knivesColumns, lmnSetting, slotSetting }
}

})